import { toast } from "./toaster";

export function useToast() {
	return { toast };
}
